var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import config from "@/config";
import { useCallback } from "react";
import { useCookies } from "react-cookie";
export var useCookiesManage = function () {
    var _a = __read(useCookies([
        "cookieConsent",
        "cookieAnalytics",
        "cookieMarketing",
        "cookiePreferences",
        "auth_c",
        "auth_p",
    ]), 3), cookies = _a[0], setCookie = _a[1], removeCookie = _a[2];
    var clearSecondaryAuthCookies = useCallback(function () {
        removeCookie("auth_c", {
            domain: config.domain,
            path: "/",
            sameSite: config.domain === "localhost" ? false : "none",
            secure: config.domain === "localhost" ? false : true,
        });
        removeCookie("auth_p", {
            domain: config.domain,
            path: "/dashboard/*",
            sameSite: config.domain === "localhost" ? false : "none",
            secure: config.domain === "localhost" ? false : true,
        });
        removeCookie("auth_p", {
            domain: config.domain,
            path: "/",
            sameSite: config.domain === "localhost" ? false : "none",
            secure: config.domain === "localhost" ? false : true,
        });
        removeCookie("auth_p", {
            domain: config.domain,
            path: "/",
            sameSite: config.domain === "localhost" ? undefined : "none",
            secure: config.domain === "localhost" ? undefined : true,
        });
    }, []);
    return {
        cookies: cookies,
        setCookie: setCookie,
        clearSecondaryAuthCookies: clearSecondaryAuthCookies,
    };
};
//# sourceMappingURL=data:application/json;base64,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